// extracted by mini-css-extract-plugin
export default {"text":"OTPVerificationModule_text__X13Mn","h2":"OTPVerificationModule_h2__2Y3PL","buttonWrapper":"OTPVerificationModule_buttonWrapper__pFkxy"};